import React from 'react';

// const DPToolBar = (props) => {

//     const toolBarButtons = window.Configs.toolBarButtons;
//     const toolBarIconType = window.Configs.toolBarIconType;
//     const toolBarIconPlace = window.Configs.toolBarIconPlace;
//     const btns = props.buttons;
//     const menuStyle = props.menuStyle;

//     let buttonDesign = (toolBarButtons == "round" ? "btn-rounded  " : "") + 'w-' + props.btnWidth + (props.btnSize != null ? ' btn-' + props.btnSize : '') + ' ';
//     let iconDesign = (toolBarIconPlace == "top" ? "d-block" : "align-middle me-2") + ' ' + (toolBarIconType == "mdi" ? "mdi mdi-" : "bx bx-");
//     var btnList = btns != null || btns.count > 1 ? btns : [];
//     let menuClass = menuStyle != null ? "btn-group" : "button-items";
//     return (
//         <React.Fragment>
//             <div className={menuClass}>
//                 {btnList.map((btn) => (
//                     <button
//                         key={btn.btnText}
//                         type="button"
//                         className={buttonDesign + "btn btn-" + btn.btnColor}
//                         onClick={btn.onClick}
//                         disabled={!btn.btnEnable}
//                         style={{ width: "106px", display: btn.btnText == "Process" ? "none" : "" }}
//                     >
//                         <i key={btn.btnText} className={iconDesign + btn.btnIcon + ' font-size-' + props.iconFont}></i>{" "}
//                         {btn.btnText}
//                     </button>
//                 ))}
//             </div>
//         </React.Fragment>
//     );
// }



const DPToolBar = (props) => {

    const Configs = {
        buttons: "round",
        toolBarButtons: "round",
        toolBarIconType: "mdi",
        toolBarIconPlace: "left",
        height: 23,
        handleDiameter: 15
    }

    const toolBarButtons = Configs.toolBarButtons;
    const toolBarIconType = Configs.toolBarIconType;
    const toolBarIconPlace = Configs.toolBarIconPlace;
    const btns = props.buttons;
    const menuStyle = props.menuStyle;

    let buttonDesign = (toolBarButtons === "round" ? "btn-rounded  " : "") + 'w-' + props.btnWidth + (props.btnSize != null ? ' btn-' + props.btnSize : '') + ' ';
    let iconDesign = (toolBarIconPlace === "top" ? "d-block" : "align-middle me-2") + ' ' + (toolBarIconType === "mdi" ? "mdi mdi-" : "bx bx-");
    var btnList = btns != null || btns.count > 1 ? btns : [];
    let menuClass = menuStyle != null ? "btn-group" : "button-items";

    return (
        <React.Fragment>
            <div className={menuClass} style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
                {btnList.map((btn) => (
                    <button
                        key={btn.btnText}
                        type="button"
                        title={btn.title}
                        className={buttonDesign + "btn btn-" + btn.btnColor}
                        onClick={btn.onClick}
                        disabled={!btn.btnEnable}
                        style={{ display: btn.btnText === "Process" ? "none" : "" }}
                    >
                        <i key={btn.btnText} className={iconDesign + btn.btnIcon + ' font-size-' + props.iconFont}></i>{" "}
                        {btn.btnText}
                    </button>
                ))}
            </div>
        </React.Fragment>
    );
}




export default DPToolBar;